import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "axios";
import V4PModalTestModel from "./V4PModalTestModel.jsx";
import SearchBar from "../SearchBar.jsx";
import ImportNewModelButton from "./ImportNewModelButton.jsx";
import ModelCard from "./ModelCard.jsx";
import useCurrentUser from "../../hooks/useCurrentUser";
// import ModelZooSelector from './ModelZooSelector.jsx'

const V4PModelZoo = ({ publicOnly = false }) => {
  const { permissions } = useCurrentUser();
  const [expandedIndex, setExpandedIndex] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [openTestModelDialog, setOpenTestModelDialog] = useState(null);
  const [zooType, setZooType] = useState("Public Model Zoo");

  const [models, setModels] = useState([]);

  const updateModel = (updatedModel) => {
    setModels((currentModels) =>
      currentModels.map((model) =>
        model.id === updatedModel.id ? { ...model, ...updatedModel } : model,
      ),
    );
  };

  const handleRuntimeAction = async (model, action) => {
    try {
      const response = await axios.post(`/v4p_models/${model.id}/${action}`);
      updateModel({ ...model, runtime_status: response.data.runtime_status });
    } catch (error) {
      console.error(`Could not ${action} V4P model`, error);
    }
  };

  const handleDeleteModel = async (model) => {
    try {
      await axios.delete(`/v4p_models/${model.id}`);
      setModels((currentModels) =>
        currentModels.filter((currentModel) => currentModel.id !== model.id),
      );
    } catch (error) {
      window.alert(
        error.response?.data?.detail || "Could not delete V4P model",
      );
    }
  };

  // const fetchModels = async () => {
  //   try {
  //     const response = await axios.get("http://localhost:8000/models/");
  //     setModels(response.data);
  //     console.log("Fetched all models:", response.data);
  //   } catch (error) {
  //     console.error("Error fetching models:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchModels();
  // }, []);

  const fetchModels = async (zooType) => {
    try {
      let url = publicOnly ? "/v4p_models/blueprint" : "/v4p_models/";

      // If viewing private zoo, fetch only user’s models
      if (!publicOnly && zooType === "Private Model Zoo") {
        url = "/v4p_models/me";
      }

      const response = await axios.get(url); // include credentials if needed
      setModels(
        [...response.data].sort((firstModel, secondModel) => {
          const createdAtOrder =
            new Date(firstModel.created_at) - new Date(secondModel.created_at);
          return createdAtOrder || firstModel.id - secondModel.id;
        }),
      );
      console.log(`Fetched ${zooType} models:`, response.data);
    } catch (error) {
      console.error("Error fetching models:", error);
    }
  };

  // fetch once on mount, but only if zooType doesn't change immediately
  useEffect(() => {
    fetchModels(zooType);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // refetch whenever zooType changes
  useEffect(() => {
    fetchModels(zooType);
  }, [zooType, publicOnly]);

  useEffect(() => {
    const isTransitioning = models.some(
      (model) =>
        model.build_status === "PENDING" ||
        model.build_status === "BUILDING" ||
        model.runtime_status === "STARTING" ||
        model.runtime_status === "STOPPING",
    );
    if (!isTransitioning) return undefined;

    const interval = setInterval(() => fetchModels(zooType), 2000);
    return () => clearInterval(interval);
  }, [models, zooType, publicOnly]);

  const handleOpenTestModelDialog = (model) => {
    setOpenTestModelDialog(model);
  };

  const handleCloseTestModelDialog = () => {
    setOpenTestModelDialog(null);
  };

  const toggleExpand = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  const filteredModels = models.filter((model) => {
    const lowerSearch = searchText.toLowerCase();
    return (
      model.name?.toLowerCase().includes(lowerSearch) ||
      model.info?.description?.toLowerCase().includes(lowerSearch) ||
      model.github_url?.toLowerCase().includes(lowerSearch)
    );
  });

  return (
    <Box
      sx={{
        mx: "auto",
        mt: 1,
        position: "relative",
        borderRadius: 4,
        overflow: "hidden",
        width: { xs: "80%", sm: "70%" },
        display: "flex",
        flexDirection: "column",
        p: 1,
      }}
    >
      {/* <Typography variant="h3" fontWeight={700} color="black" mt={4}>
            {publicOnly ? 'QM Blueprint' : 'Model Zoo'}
        </Typography> */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 6, mt: 2 }}>
        <Typography variant="h3" fontWeight={700} color="black" mt={2}>
          Model Zoo
        </Typography>
        <Box
          sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2, mt: 2 }}
        >
          {/* <ModelZooSelector value={zooType} onChange={setZooType} /> */}
        </Box>
      </Box>

      <Box sx={{ display: "flex", alignItems: "center", gap: 2, mb: 2, mt: 2 }}>
        <Typography variant="h6" color="rgb(158, 151, 151)" mt={2}>
          {publicOnly
            ? "Explore public technologies developed by the V4P Q&M team."
            : "Explore technologies developed by the V4P Q&M team."}
        </Typography>
        {/* <Box sx={{ ml: 'auto', transform: 'scale(1.2)', transformOrigin: 'right' }}>
            <ImportNewModelButton refreshModels={fetchModels} />
            </Box> */}
        {!publicOnly &&
          zooType === "Public Model Zoo" &&
          permissions.includes("view_import_v4p_model_button") && (
            <Box
              sx={{
                ml: "auto",
                transform: "scale(1.2)",
                transformOrigin: "right",
              }}
            >
              <ImportNewModelButton
                refreshModels={() => fetchModels(zooType)}
              />
            </Box>
          )}
      </Box>

      {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2, mt: 2 }}>
            <ModelZooSelector value={zooType} onChange={setZooType} />
        </Box> */}

      <Box mt={4} sx={{ width: "100%" }}>
        <SearchBar
          searchText={searchText}
          setSearchText={setSearchText}
          placeholder="Search models"
        />
      </Box>

      {/* <Typography variant="h4" fontWeight={700} color="black" mt={4}>
            Available Models
        </Typography> */}
      {/* <Typography variant="h4" fontWeight={700} color="black" mt={4}>
          {zooType === "Public Model Zoo" ? "Public Models" : "Private Models"}
        </Typography> */}

      <Box
        sx={{
          mt: 2,
          display: "flex",
          flexDirection: "column",
          gap: 3,
          borderRadius: 2,
          p: 2,
        }}
      >
        {filteredModels.length === 0 ? (
          <Typography variant="body1" color="text.secondary">
            No models found matching your search.
          </Typography>
        ) : (
          filteredModels.map((model, index) => (
            <ModelCard
              key={model.id}
              model={model}
              expanded={expandedIndex === index}
              onToggleExpand={() => toggleExpand(index)}
              onTest={() => handleOpenTestModelDialog(model)}
              onRuntimeAction={handleRuntimeAction}
              canEdit={!publicOnly && permissions.includes("edit_v4p_models")}
              onEdit={
                !publicOnly && permissions.includes("edit_v4p_models")
                  ? updateModel
                  : null
              }
              onDelete={
                !publicOnly && permissions.includes("delete_v4p_models")
                  ? () => handleDeleteModel(model)
                  : null
              }
            />
          ))
        )}
      </Box>

      {openTestModelDialog !== null && (
        <V4PModalTestModel
          open={openTestModelDialog !== null}
          model={openTestModelDialog}
          onClose={handleCloseTestModelDialog}
        />
      )}
    </Box>
  );
};

export default V4PModelZoo;
